<template>
  <component :is="formComponent" :item="item"></component>
</template>

<script>
  import BaseItem from './nav-menu-items/BaseItem.vue';
  import DashboardItem from './nav-menu-items/DashboardItem.vue';
  import LogoutItem from './nav-menu-items/LogoutItem.vue';

  export default {
    name: 'NavMenuItem',
    components: {
      BaseItem,
      DashboardItem,
      LogoutItem,
    },
    props: {
      item: {
        type: Object,
      },
    },
    data() {
      return {};
    },
    computed: {
      formComponent() {
        if (this.item.title === 'sign out') {
          return 'LogoutItem';
        }
        if (this.item.title === 'can_contact_am_rd') {
          return 'ContactTeamItem';
        }
        return 'BaseItem';
      },
    },
  };
</script>
